import Map from '../components/modules/map/index';
import HereMap from '../components/modules/map/HereMap';
import TrackMap from '../components/modules/track/TrackMap';
import ActiveTripMap from '../components/track/MapCluster';

const map = [
  {
    path: '/map',
    name: 'Map',
    component: Map,
    meta: {
      title: 'Map',
    },
  },
  {
    path: '/hereMap',
    name: 'HereMap',
    component: HereMap,
    meta: {
      title: 'Map',
    },
  },
  {
    path: '/track/map',
    name: 'TrackMap',
    component: TrackMap,
    meta: {
      title: 'Track Map',
    },
  },
  {
    path: '/activeTrips/map',
    name: 'ActiveTripMap',
    component: ActiveTripMap,
    meta: {
      title: 'Active Trip Map',
    },
  },
];

export default map;
